<template>
    <div class="position-relative">
        <label class="font-semibold">{{label}}</label>
        <input
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :name="name"
            :class="['custom-input', {'is-invalid': isInvalid}]"
            :placeholder="placeholder"
            :maxlength="maxLength"
            @focus="$emit('focus')"
        >

        <span class="char-counter">
            {{ remainingCharacters(modelValue) }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: [String, null],
        label: String,
        maxLength: {
            type: Number,
            default: 30
        },
        placeholder: String,
        isInvalid: {
            type: Boolean,
            default: false
        },
        name: String
    },
    methods: {
        remainingCharacters(value, max = 30) {
            const length = (value || '').length;
            return Math.max(max - length, 0);
        }
    }
}
</script>

<style scoped>
.char-counter {
    position: absolute;
    right: 10px;
    top: 72%;
    transform: translateY(-50%);
    font-size: 0.75rem;
    color: #ccc;
    pointer-events: none;
}

.custom-input {
    width: 100%;
    padding-right: 2.5rem;
}
</style>